import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

interface NavItem {
  label: string;
  path: string;
}

/**
 * App Navigation Component
 * Horizontal navigation menu
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive],
  selector: 'app-navigation',
  standalone: true,
  styleUrl: './navigation.component.scss',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {
  navItems = signal<NavItem[]>([
    { label: 'EXPLORE REFINERY', path: '/refinery/explore' },
    { label: 'ASK AI', path: '/ask-ai' },
  ]);
}
